<template lang="pug">
div.animated.fadeIn(style='max-height: calc( 100vh - 150px)')
  b-img.chatflow(src='static/img/chatflow.png' alt='ChatFlow' style='height: 100%;')
  //- iframe.chatflow(src='https://www.chatbase.com/overview?botKey=005f4c4c-e61a-4cd6-b60b-f23424881c79&platform=__any__&version=__any__&period=1&cohortsPeriod=6week')
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
    }
  },
  mounted: function() {
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Data.vue?1cb24cef